import React, { useState } from 'react';
import styled from 'styled-components';
import IterationTimeline from '../IterationGraph/IterationTimeline/IterationTimeline';
import { getTimelineData } from '../../pulse.service';
import Table from 'components/base/Table';
import { Flex } from 'components/base/layout-components';
import withUnmatchedBranchesData from './withUnmatchedBranchesData';
import Accordion from 'components/base/Accordion';
import { StuckHeader } from './styles';
import UnMatchedBranchesTitle from './UnMatchedBranchesTitle';
import { getColor } from 'common/constants/_colors';
import * as TrackingService from 'common/services/tracking.service';
import { TRACKING } from 'common/constants/constants';

const TableWrapper = styled(Flex)`
  flex-direction: column;
  width: 100%;
  background-color: ${getColor('white')};
  .MuiTableRow-head {
    border-top: 0 !important;
  }
`;

const UnMatchedBranches = ({
  iterations,
  workingDays,
  data,
  selectedContributorIds,
  isOpen = true,
  setIsOpen,
  scrollIntoUnmatchedBranches,
  setScrollIntoUnmatchedBranches
}) => {
  const [tableHeight, setTableHeight] = useState('0');
  const [headerHeight, setHeaderHeight] = useState('0');

  const columns = [
    {
      name: '',
      dataPoint: 'branch',
      tableCellProps: {
        style: {
          width: '38%',
          minWidth: '20rem'
        }
      }
    },
    {
      name: 'PEOPLE',
      dataPoint: 'people',
      tableCellProps: {
        style: {
          width: '13.5%',
          minWidth: '10rem'
        }
      }
    },
    {
      name: 'LAST ACTIVITY',
      dataPoint: 'lastActivity',
      tableCellProps: {
        style: {
          width: '31%',
          minWidth: '10rem'
        }
      }
    },
    {
      name: '',
      dataPoint: 'timeline',
      tableCellProps: {
        style: {
          width: '45rem',
          padding: 0
        }
      },
      ColumnHeaderComponent: () => (
        <IterationTimeline
          tableHeight={tableHeight}
          {...getTimelineData(iterations)}
          workingDays={workingDays}
          selectedContributorIds={selectedContributorIds}
        />
      )
    },
    {
      name: '',
      dataPoint: 'stuck',
      tableCellProps: {
        style: {
          width: '9%',
          minWidth: '10rem',
          padding: '0.8rem 0'
        }
      },
      ColumnHeaderComponent: () => (
        <StuckHeader pl='1.2rem' pr='1.2rem'>
          ALERTS
        </StuckHeader>
      )
    }
  ];

  if (!data.length) {
    return null;
  }

  return (
    <Accordion
      CollapseIcon={() => null}
      setIsOpen={setIsOpen}
      isOpen={isOpen}
      onClick={() => {
        TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
          page: TRACKING.PAGES.PULSE,
          click_type: TRACKING.CLICK.UNMATCHED_BRANCHES
        });
      }}
      titleComponent={
        <UnMatchedBranchesTitle
          setTableHeight={setHeaderHeight}
          tableHeight={tableHeight}
          iterations={iterations}
          workingDays={workingDays}
          selectedContributorIds={selectedContributorIds}
          columns={columns}
          isOpen={isOpen}
          branchesNumber={data.length}
          scrollIntoUnmatchedBranches={scrollIntoUnmatchedBranches}
          setScrollIntoUnmatchedBranches={setScrollIntoUnmatchedBranches}
        />
      }
      timeout={0}
    >
      <TableWrapper>
        <Table
          tableComponentProps={{
            ref: el => {
              setTableHeight(
                `${
                  el
                    ? el.getBoundingClientRect().height +
                      +headerHeight.replace('px', '') -
                      34
                    : 0
                }px`
              );
            }
          }}
          lineHighlightOnHover
          data={data}
          columns={columns}
          withTableHead={false}
        />
      </TableWrapper>
    </Accordion>
  );
};

export default withUnmatchedBranchesData(UnMatchedBranches);
